import { strategyToOptions } from '@/common/utils/strategyToOptions'

export enum SolicitationStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  DISCARDED = 'discarded',
}

export const solicitationStatusTranslation = {
  [SolicitationStatus.PENDING]: 'Sem processo',
  [SolicitationStatus.IN_PROGRESS]: 'Em Progresso',
  [SolicitationStatus.COMPLETED]: 'Concluída',
  [SolicitationStatus.DISCARDED]: 'Descartada',
}

export const solicitationStatusOptions = strategyToOptions(solicitationStatusTranslation)
